<template>
  <header id="header" class="fixed-top">
    <div class="container-fluid px-5">
      <Reveal class="d-blcok d-sm-none">
        <a id="home" href="#">
          <ul class="nav navbar-nav">
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown"
                >Products
              </a>
              <ul class="dropdown-menu">
                <li>
                  <router-link to="/cloud-design">3D Cloud design</router-link>
                </li>
                <li>
                  <router-link to="3d-model">3D Models & Viewer</router-link>
                </li>
                <li>
                  <router-link to="virtual">360º Virtual Showroom</router-link>
                </li>
                <li>
                  <router-link to="studio">Photo & video studio</router-link>
                </li>
                <!-- <li>
                  <router-link to="asset">Asset management</router-link>
                </li> -->
                <li class="no-active">
                  <router-link to="/content">Content creation</router-link>
                </li>
              </ul>
            </li>
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown"
                >Solutions
              </a>
              <ul class="dropdown-menu">
                <li>
                  <router-link to="professionals">Professionals</router-link>
                </li>
                <li><router-link to="brands">Brands</router-link></li>
                <!-- <li><router-link to="vr">VR</router-link></li>
                <li><router-link to="retail">Retail</router-link></li> -->
                <li><router-link to="estate">Real estate</router-link></li>
              </ul>
            </li>
            <li class="dropdown">
              <router-link to="/inspiration">Inspiration </router-link>
            </li>
            <li class="dropdown">
              <router-link to="/subscription">Subscriptions </router-link>
            </li>
          </ul>
        </a>
      </Reveal>
      <div class="row">
        <div class="col-md-2 pull-left">
          <router-link to="/" class="logo mr-auto no-active">
            <img src="@/assets/img/grey.png" alt="logo" />
            <!-- <img src="@/assets/img/aixperia_new_logo.jpg" alt="logo" /> -->
          </router-link>
        </div>
        <div class="col-md-6 d-flex justify-content-start">
          <nav class="nav-menu d-none d-sm-block">
            <ul>
              <li class="drop-down">
                <a href="">Products</a>
                <ul>
                  <li>
                    <router-link to="/cloud-design"
                      >3d Cloud design</router-link
                    >
                  </li>
                  <li>
                    <router-link to="3d-model">3D Models & Viewer</router-link>
                  </li>
                  <li>
                    <router-link to="virtual"
                      >360º Virtual Showroom</router-link
                    >
                  </li>
                  <li>
                    <router-link to="studio">Photo& video studio</router-link>
                  </li>
                  <!-- <li>
                    <router-link to="asset">Asset management</router-link>
                  </li> -->
                  <li>
                    <router-link to="/content">Content creation</router-link>
                  </li>
                </ul>
              </li>
              <li class="drop-down">
                <a href="">Solutions</a>
                <ul>
                  <li>
                    <router-link to="professionals">Professionals</router-link>
                  </li>
                  <li><router-link to="brands">Brands</router-link></li>
                  <!-- <li><router-link to="vr">VR</router-link></li>
                  <li><router-link to="retail">Retail</router-link></li> -->
                  <li><router-link to="estate">Real estate</router-link></li>
                </ul>
              </li>
              <li>
                <router-link to="/inspiration" class="no-active"
                  >Inspiration</router-link
                >
              </li>
              <li>
                <router-link to="/subscription" class="no-active"
                  >Subscriptions</router-link
                >
              </li>
              <!-- <li class="drop-down"><a href="">Support</a>
                        <ul>
                            <li><a href="#">Tutorials</a></li>
                            <li><a href="#">Resources</a></li>
                        </ul>
                    </li> -->
              <!-- <li><a href="#contact">Contact us</a></li> -->
            </ul>
            <!-- <translate-modal></translate-modal> -->
          </nav>
        </div>
        <div class="col-md-4 d-flex justify-content-end">
          <a
            v-if="userData"
            @click="CheckLogin"
            class="pt-2 pr-5 menu-link-right"
            >{{ this.firstname }}</a
          >
          <a v-else @click="showLoginModal()" class="pt-2 pr-5 menu-link-right">
            Login</a
          >
          <!-- <a
            @click="showSingnupModal()"
            class="mx-5 pt-2 btn btn-outline-secondary menu-link-right"
          >
            Get Started</a
          > -->

          <div class="pt-2">
            <a
              class="lang-settings menu-link-right"
              type="button"
              id="dropdownMenu2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span>EN</span><i class="bx bx-globe pl-1"></i>
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
              <Translator
                :countries="countries"
                @on-country-click="hideModal"
              />
            </div>
          </div>
          <!-- <router-link to="/site" class="mx-5 pt-2 btn btn-secondary btn-sm">
            Home
          </router-link> -->
        </div>
        <login-view
          v-on:ShowVerification="ShowVerification"
          v-on:ShowForgotForm="ShowForgotForm"
        ></login-view>
        <signup-view
          v-on:ShowLogin="ShowLogin"
          v-bind:email="email"
          v-bind:socialData="socialData"
        ></signup-view>
        <verification-view
          v-on:VerifySignup="VerifySignup"
          v-bind:socialData="socialData"
        ></verification-view>
        <forgotpassword-view></forgotpassword-view>
      </div>
    </div>
  </header>
</template>
<script>
import { Reveal } from "vue-burger-menu";
import { Translator } from "vue-google-translate";
import LoginView from "@/views/site/LoginView";
import SignupView from "@/views/site/SignupView";
import VerificationView from "@/views/site/VerificationView";
import ForgotpasswordView from "@/views/site/ForgotpasswordView.vue";
export default {
  name: "MenuBar",
  components: {
    LoginView,
    SignupView,
    VerificationView,
    Translator,
    ForgotpasswordView,
    Reveal,
  },
  data() {
    return {
      socialData: [],
      firstname: "",
      email: "",
      countries: [
        {
          code: "en|zh-CN",
          title: "Chinese (Simplified)",
        },
        {
          code: "en|en",
          title: "English",
        },
        {
          code: "en|fr",
          title: "French",
        },
        {
          code: "en|it",
          title: "Italian",
        },
        {
          code: "en|ja",
          title: "Japanese",
        },
        {
          code: "en|ko",
          title: "Korean",
        },
        {
          code: "en|es",
          title: "Spanish",
        },
        {
          code: "en|th",
          title: "Thai",
        },
      ],
    };
  },
  created() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    this.userData = userData;
    if (this.userData != null) {
      this.firstname = userData.user.firstname;
    }
  },
  methods: {
    showLoginModal() {
      $("#loginModal").modal("show");
    },
    showSingnupModal() {
      $("#signupModal").modal("show");
    },
    VerifySignup(email) {
      this.email = email;
      console.log(this.email);
      $("#signupModal").modal("show");
    },
    ShowSignUp() {
      $("#loginModal").modal("hide");
      $("#signupModal").modal("show");
    },
    ShowVerification() {
      $("#loginModal").modal("hide");
      $("#verificationModal").modal("show");
    },

    ShowForgotForm() {
      $("#loginModal").modal("hide");
      $("#ResetModal").modal("show");
    },

    ShowLogin() {
      $("#loginModal").modal("show");
      $("#signupModal").modal("hide");
    },
    hideModal() {
      // this.$bvModal.hide("translate-modal");
    },
    CheckLogin() {
      var token = localStorage.getItem("userData");
      var userdata_array = JSON.parse(token);
      var api_token = userdata_array.user.api_token;
      let method_type = "";
      let fetch_url = "";
      method_type = "post";
      fetch_url = process.env.VUE_APP_URL + "customer/getLogData";
      fetch(fetch_url, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Authorization: "Bearer " + api_token,
        },
        body: JSON.stringify({
          token: api_token,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            window.location.href = "/";
            this.name = data.customer.firstname;
            this.userData = data.customer;
            var userData = {
              user: data.customer,
              // token: data.token,
              status: true,
            };
            localStorage.setItem("userData", JSON.stringify(userData));
            if (process.env.NODE_ENV === "development") {
              window.location.href =
                "http://localhost:8081/account/" +
                data.customer.cross_pltaform_token;
            } else {
              window.location.href =
                "https://account.aixperia.com/account/" +
                data.customer.cross_pltaform_token;
              //  window.location.href = "https://account.aixperia.com/account/" +
              // data.customer.cross_pltaform_token;
            }
          }
          if (data.status === false) {
            this.$swal
              .fire({
                title: "Session Expired",
                text: "Please login to continue !",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "ok",
              })
              .then((result) => {
                localStorage.clear();
                if (process.env.NODE_ENV === "development") {
                  // window.location.href = "http://example.com";
                  window.location.href = "http://localhost:8080/logout";
                } else {
                  window.location.href = "https://www.aixperia.com/logout";
                }
              });
          } else {
            this.loader = false;
            this.errors = data.errors;
          }
        })
        .catch(function(err) {
          console.log("User Data", "Error : " + err.message, "error");
        });
    },
  },
  mounted() {
    $("ul.nav li.dropdown").hover(
      function() {
        $(this)
          .find(".dropdown-menu")
          .stop(true, true)
          .delay(200)
          .fadeIn(500);
      },
      function() {
        $(this)
          .find(".dropdown-menu")
          .stop(true, true)
          .delay(200)
          .fadeOut(500);
      }
    );
    var rafId = null;
    var delay = 200;
    var lTime = 0;

    function scroll() {
      var scrollTop = $(window).scrollTop();
      var height = $(window).height();
      var visibleTop = scrollTop + height;
      $(".reveal").each(function() {
        var $t = $(this);
        if ($t.hasClass("reveal_visible")) {
          return;
        }
        var top = $t.offset().top;
        if (top <= visibleTop) {
          if (top + $t.height() < scrollTop) {
            $t.removeClass("reveal_pending").addClass("reveal_visible");
          } else {
            $t.addClass("reveal_pending");
            if (!rafId) requestAnimationFrame(reveal);
          }
        }
      });
    }
    function reveal() {
      rafId = null;
      var now = performance.now();

      if (now - lTime > delay) {
        lTime = now;
        var $ts = $(".reveal_pending");
        $($ts.get(0))
          .removeClass("reveal_pending")
          .addClass("reveal_visible");
      }

      if ($(".reveal_pending").length >= 1)
        rafId = requestAnimationFrame(reveal);
    }

    $(scroll);
    $(window).scroll(scroll);
    $(window).click(function() {
      $(".reveal")
        .removeClass("reveal_visible")
        .removeClass("reveal_pending");
      lTime = performance.now() + 500;
      var top = $(window).scrollTop();
      $(window).scrollTop(top === 0 ? 1 : top - 1);
    });
  },
};
</script>
<style>
/* gets rid of the banner at the top of the page */
body {
  top: 0 !important;
}
/* get rids of the banner at the bottom of the web page */
.skiptranslate {
  display: none !important;
}
</style>
